import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import DossierActions from "../redux/DossierRedux";
import { Link } from "react-router-dom";

import Layout from "../components/Layout";
import HeaderForm from "../components/HeaderForm/HeaderForm";
import Button from "../components/UI/Button/Button";
import Input from "../components/UI/Input/Input";
import FormError from "../components/UI/FormError/FormError";
import {
  updateObject,
  checkValidity,
  getDate,
  isFormReadOnly,
  getFormErrors,
} from "../shared/utility";
import { adresse } from "../shared/staticTexts";

class DossierAdressePage extends React.Component {
  constructor(props) {
    super(props);
    if (props.dossier === null) {
      props.history.push("/dossier");
    }
    const dossier = props.dossier;

    this.state = {
      form: {
        dateDebutActivite: {
          elementType: "datepicker",
          elementConfig: {
            type: "input",
            name: "dateDebutActivite",
            classes: "w-100",
          },
          validation: {
            required: true,
          },
          value:
            dossier && dossier.entity.dateDebutActivite
              ? getDate(dossier.entity.dateDebutActivite)
              : "",
          valid: false,
          touched: false,
        },
        adresse: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "adresse",
            placeholder: adresse.form.adresse.placeholder,
          },
          validation: {
            required: true,
          },
          value:
            dossier && dossier.entity.adresse ? dossier.entity.adresse : "",
          valid: false,
          touched: false,
        },
        codePostal: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "codePostal",
            placeholder: adresse.form.codePostal.placeholder,
          },
          validation: {
            required: true,
            minLength: 5,
            maxLength: 5,
          },
          value:
            dossier && dossier.entity.codePostal
              ? dossier.entity.codePostal
              : "",
          valid: false,
          touched: false,
        },
        ville: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "ville",
            placeholder: adresse.form.ville.placeholder,
          },
          validation: {
            required: true,
          },
          value: dossier && dossier.entity.ville ? dossier.entity.ville : "",
          valid: false,
          touched: false,
        },
      },
      siren: dossier && dossier.entity.siren ? dossier.entity.siren : null,
      formErrors: [],
      formIsValid: false,
      isUpdated: false,
      isSubmitted: false,
      dossier: dossier,
      isReadOnlyForm: isFormReadOnly(dossier),
    };
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (
      prevState.isSubmitted &&
      nextProps.dossier !== null &&
      prevState.dossier !== null
    ) {
      if (nextProps.dossier !== prevState.dossier) {
        nextProps.history.replace("/dossier/votre-bien");
      }
    }
    return nextProps;
  };

  submitHandler = (event) => {
    event.preventDefault();

    if (
      this.props.dossier &&
      this.props.dossier.status &&
      this.props.dossier.status !== "EnSaisie"
    ) {
      this.props.history.replace("/dossier/votre-bien");
      return false;
    }

    let formElements = {};
    for (let formElementIdentifier in this.state.form) {
      const formElementValue = this.state.form[formElementIdentifier].value;
      const updatedFormElement = updateObject(
        this.state.form[formElementIdentifier],
        {
          value: formElementValue,
          valid: checkValidity(
            formElementValue,
            this.state.form[formElementIdentifier].validation
          ),
          touched: true,
        }
      );

      formElements[formElementIdentifier] = updatedFormElement;
    }

    let formIsValid = true;
    let formData = {};
    for (let formElementIdentifier in formElements) {
      formIsValid = formElements[formElementIdentifier].valid && formIsValid;
      const value = formElements[formElementIdentifier].value;
      if (formElementIdentifier === "dateDebutActivite") {
        formData[formElementIdentifier] = moment(value).format("YYYY-MM-DD");
      } else {
        formData[formElementIdentifier] = value;
      }
    }

    this.setState({
      form: formElements,
      formIsValid: formIsValid,
      formErrors: getFormErrors(formElements),
    });

    if (formIsValid) {
      if (this.state.isUpdated) {
        let {
          timestampCreation,
          timestampModification,
          ...dossier
        } = this.props.dossier;
        dossier.entity = { ...dossier.entity };
        for (let key in formData) {
          dossier.entity[key] = formData[key];
        }
        this.setState({ isSubmitted: true });
        this.props.saveDossier(dossier);
      } else {
        this.props.history.replace("/dossier/votre-bien");
      }
    }
  };

  inputChangeDatePickerHandler = (date, controlName) => {
    const updatedFormElement = updateObject(this.state.form[controlName], {
      value: date,
      valid: checkValidity(date, this.state.form[controlName].validation),
      touched: true,
    });

    const updatedForm = updateObject(this.state.form, {
      [controlName]: updatedFormElement,
    });

    let formIsValid = true;
    for (let controlName in updatedForm) {
      formIsValid = updatedForm[controlName].valid && formIsValid;
    }

    this.setState({
      form: updatedForm,
      formIsValid: formIsValid,
      isUpdated: true,
    });
  };

  inputChangedHandler = (event, inputIdentifier) => {
    const updatedFormElement = updateObject(this.state.form[inputIdentifier], {
      value: event.target.value,
      valid: checkValidity(
        event.target.value,
        this.state.form[inputIdentifier].validation
      ),
      touched: true,
    });

    const updatedForm = updateObject(this.state.form, {
      [inputIdentifier]: updatedFormElement,
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      form: updatedForm,
      formIsValid: formIsValid,
      isUpdated: true,
    });
  };

  render() {
    let errorsMessages = "";
    if (this.props.error && this.props.errorMessage !== null) {
      errorsMessages = (
        <div className="alert alert-danger" role="alert">
          {this.props.errorMessage}
        </div>
      );
    }

    const formElementsArray = [];
    for (let key in this.state.form) {
      formElementsArray.push({
        id: key,
        config: this.state.form[key],
      });
    }

    let form = (
      <form
        className="dossier-form dossier-step2 py-5"
        onSubmit={this.submitHandler}
      >
        {this.state.siren !== null ? (
          <div className="form-row mb-3">
            <div className="col-sm-6 text-right">
              <label className="col-form-label">SIREN</label>
            </div>
            <div className="col-sm-3">
              <input
                className="form-control"
                type="text"
                placeholder="SIREN"
                defaultValue={this.state.siren}
                readOnly="readOnly"
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="form-row mb-3">
          <div className="col-sm-6 text-right">
            <label
              htmlFor={formElementsArray[0].id}
              className="col-form-label required"
            >
              {adresse.form.dateDebutActivite.label}
            </label>
          </div>
          <div className="col-sm-3">
            <Input
              key={formElementsArray[0].id}
              elementType={formElementsArray[0].config.elementType}
              elementConfig={formElementsArray[0].config.elementConfig}
              label={formElementsArray[0].config.label}
              value={formElementsArray[0].config.value}
              invalid={!formElementsArray[0].config.valid}
              shouldValidate={formElementsArray[0].config.validation}
              touched={formElementsArray[0].config.touched}
              isReadOnly={this.state.isReadOnlyForm}
              selected={(date) =>
                this.inputChangeDatePickerHandler(date, formElementsArray[0].id)
              }
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-sm-6 text-right">
            <label
              htmlFor={formElementsArray[1].id}
              className="col-form-label required"
            >
              {adresse.form.adresse.label}
            </label>
          </div>
          <div className="col-sm-3">
            <Input
              key={formElementsArray[1].id}
              elementType={formElementsArray[1].config.elementType}
              elementConfig={formElementsArray[1].config.elementConfig}
              label={formElementsArray[1].config.label}
              value={formElementsArray[1].config.value}
              invalid={!formElementsArray[1].config.valid}
              shouldValidate={formElementsArray[1].config.validation}
              touched={formElementsArray[1].config.touched}
              isReadOnly={this.state.isReadOnlyForm}
              changed={(event) =>
                this.inputChangedHandler(event, formElementsArray[1].id)
              }
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-sm-3 offset-sm-6">
            <div className="form-row">
              <div className="col-sm-6">
                <Input
                  key={formElementsArray[2].id}
                  elementType={formElementsArray[2].config.elementType}
                  elementConfig={formElementsArray[2].config.elementConfig}
                  label={formElementsArray[2].config.label}
                  value={formElementsArray[2].config.value}
                  invalid={!formElementsArray[2].config.valid}
                  shouldValidate={formElementsArray[2].config.validation}
                  touched={formElementsArray[2].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[2].id)
                  }
                />
              </div>
              <div className="col-sm-6">
                <Input
                  key={formElementsArray[3].id}
                  elementType={formElementsArray[3].config.elementType}
                  elementConfig={formElementsArray[3].config.elementConfig}
                  label={formElementsArray[3].config.label}
                  value={formElementsArray[3].config.value}
                  invalid={!formElementsArray[3].config.valid}
                  shouldValidate={formElementsArray[3].config.validation}
                  touched={formElementsArray[3].config.touched}
                  isReadOnly={this.state.isReadOnlyForm}
                  changed={(event) =>
                    this.inputChangedHandler(event, formElementsArray[3].id)
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="col-sm-6 mt-3 text-right">
            <Link to="/nouveau-dossier" className="btn btn-default">
              {adresse.buttonReturn}
            </Link>
          </div>
          <div className="col-sm-3 mt-3 text-right">
            <Button classes="btn btn-success" btnType="Submit">
              {adresse.buttonSubmit}
            </Button>
          </div>
        </div>

        <FormError errors={this.state.formErrors} />
      </form>
    );

    return (
      <Layout>
        {errorsMessages}
        <HeaderForm step="1" isReadOnlyForm={this.state.isReadOnlyForm} />
        <h1 className="text-center">{adresse.title}</h1>
        {form}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDossier: (dossier) => dispatch(DossierActions.saveDossier(dossier)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DossierAdressePage);
